import React from 'react';
import { Table } from 'react-bootstrap';



const TableCustomized: React.FC = ({ children }) => {

    return (
            <Table size='sm'  striped bordered hover  responsive="sm" >
                {children}
            </Table>

    );
};

export default TableCustomized